import React, { useState, useEffect } from 'react';

import { getTodayDate } from "../../hocs/dateServices";
import { notification } from '../../hocs/notification';
import axios from 'axios';
import { mainurl } from '../../../Mainurl';
import AddProduceRow from './AddProduceRow';

import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Input, 
    InputGroup,
    InputGroupText,
    Label, 
    Button, 
    Form, 
    CardFooter,
    Badge,
    Alert,
    Spinner,
    Progress
} from 'reactstrap';

import {
    FaPlusCircle,
    FaArrowLeft,
    FaShoppingCart,
    FaUser,
    FaShoppingBag,
    FaBoxOpen,
    FaWeight,
    FaRupeeSign,
    FaUsers,
    FaEdit,
    FaTrash,
    FaCalculator,
    FaCheck,
    FaSave,
    FaStore,
    FaTruck,
    FaMapMarkerAlt,
    FaSearch,
    FaLeaf,
    FaStar,
    FaUserTie
} from 'react-icons/fa';

const ProducePurchase = ({back, ...props}) => {

    const [loading, setLoading] = useState('');
    const [submitLoading, setSubmitLoading] = useState(false);
    const [farmerLoading, setFarmerLoading] = useState(false);

    const [state, setState] = useState('0');
    const [district, setDistrict] = useState('0');
    const [block, setBlock] = useState('0');
    
    const [stateOpt, setStateOpt] = useState('');
    const [districtOpt, setDistrictOpt] = useState('');
    const [blockOpt, setBlockOpt] = useState('');
    const [prodOpt, setProdOpt] = useState('');
    const [farmerList, setFarmerList] = useState('');

    const [farmer, setFarmer] = useState('');
    
    const [category, setCategory] = useState('');
    const [product, setProduct] = useState('');
    const [productName, setProductName] = useState('');
    const [rate, setRate] = useState('');
    const [qty, setQty] = useState('');
    const [unit, setUnit] = useState();
    const [unitName, setUnitName] = useState('');
    const [grade, setGrade] = useState();
    const [gradeName, setGradeName] = useState('');

    const [addList, setAddList] = useState('');
    const [addListArry, setAddListArry] = useState([]);
    const [currRow, setCurrRow] = useState('');
    const [updateRow, setUpdateRow] = useState(false);
    const [totalPrice, setTotalPrice] = useState('');
    
    useEffect(()=> {
        get_state_list();
    },[]);

    const get_state_list = (e) => {
        let postData = [{"country_code": "1"}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.state_code}> {row.state_name}</option>
                    )
                });

                setStateOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_dist_list = (e) => {
        setState(e.target.value);
        setDistrict('0'); // Reset district when state changes
        setBlock('0'); // Reset block when state changes
        setFarmerList(''); // Reset farmer list
        setFarmer(''); // Reset selected farmer
        
        let postData = [{"state_code": e.target.value}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.district_code}> {row.district_name}</option>
                    )
                });

                setDistrictOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_block_list = (e) => {
        setDistrict(e.target.value);
        setBlock('0'); // Reset block when district changes
        setFarmerList(''); // Reset farmer list
        setFarmer(''); // Reset selected farmer
        
        let postData = [{"dist_code": e.target.value}]
        axios({
            method: 'post',
            url: mainurl + 'Master/get_block_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.block_code}> {row.block_name}</option>
                    )
                });

                setBlockOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_farmer_list = (e) => {
        setFarmerLoading(true);
        setFarmerList('');
        setFarmer('');
        e.preventDefault();
        
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": "101", "dist_id": district, "block_id": block, "vill_id":0}];
        axios({
            method: 'post',
            url: mainurl +'Farmer/box_farmer_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.farmer_code}> {row.f_name +" ("+ row.f_name_ne +")"} </option>
                    )
                });

                setFarmerList(list);
                setFarmerLoading(false);
                
                let notify = notification({ 
                    message: `Found ${response.data.length} farmers in selected location`, 
                    type: 'success' 
                });
                notify();
            })
            .catch(error => {
                setFarmerLoading(false);
                let notify = notification({ 
                    message: "Failed to load farmers. Please try again.", 
                    type: 'error' 
                });
                notify();
            });
    }

    const get_product_list = (id) => {
        let postData = [{"org_id": "101", "user_id": "101", "crop_type_id": id, "lang_id": 1}];
        axios({
            method: 'post',
            url: mainurl + 'Master/box_crop_master_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    return(
                        <option key={index} value={row.crop_code}> {row.crop_name}</option>
                    )
                }) 

                setProdOpt(list);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const add_row_handler = (e) => {
        e.preventDefault();

        if (!product || !qty || !unit || !rate || !grade) {
            let notify = notification({ 
                message: "Please fill all required fields", 
                type: 'warning' 
            });
            notify();
            return;
        }

        let list = { 
            "product": product, 
            "productName": productName, 
            "grade": grade, 
            "gradeName": gradeName, 
            "qty": qty, 
            "unit": unit, 
            "unitName": unitName, 
            "rate": rate 
        };
        let tempArry = [...addListArry];
        
        tempArry.push(list);
        setAddListArry(tempArry);
        
        updateProductList(tempArry);
        clearProductForm();

        let notify = notification({ 
            message: "Product added successfully", 
            type: 'success' 
        });
        notify();
    }

    const updateProductList = (tempArry) => {
        let total = 0;
        if (tempArry.length > 0) {
            let add_list = tempArry.map((row, index) => {
                total = total + (Number(row.rate) * Number(row.qty));
                return (
                    <AddProduceRow 
                        data={row} 
                        index={index} 
                        edit={() => edit_handler(row, index)} 
                        del={() => delete_handler(index)} 
                        key={index}  
                    /> 
                )
            });
            setAddList(add_list);
            setTotalPrice(total);
        }
    }

    const clearProductForm = () => {
        setProduct('');
        setProductName('');
        setQty('');
        setUnit('');
        setUnitName('');
        setRate('');
        setGrade('');
        setGradeName('');
    }

    const edit_handler = (row, rowNo) => {
        setCurrRow(rowNo);
        setUpdateRow(true);
        setProduct(row.product);
        setProductName(row.productName);
        setQty(row.qty);
        setUnit(row.unit);
        setUnitName(row.unitName);
        setRate(row.rate);
        setGrade(row.grade);
        setGradeName(row.gradeName);
    }

    const update_edit_handler = () => {
        let list = { 
            "product": product, 
            "productName": productName,
            "grade": grade, 
            "gradeName": gradeName, 
            "qty": qty, 
            "unit": unit, 
            "unitName": unitName, 
            "rate": rate 
        };
        let updateList = [...addListArry];
        updateList.splice(currRow, 1, list);

        setAddListArry(updateList);
        updateProductList(updateList);
        clearProductForm();
        setCurrRow('');
        setUpdateRow(false);

        let notify = notification({ 
            message: "Product updated successfully", 
            type: 'success' 
        });
        notify();
    }

    const delete_handler = (rowNo) => {
        let delListArry = [...addListArry];
        
        delListArry.splice(rowNo, 1);
        setAddListArry(delListArry);
        
        let total = 0;
        if (delListArry.length > 0) {
            updateProductList(delListArry);
        } else {
            setAddList('');
            setTotalPrice(0);
        }

        let notify = notification({ 
            message: "Product removed successfully", 
            type: 'info' 
        });
        notify();
    }

    const sale_handler = () => {
        if (!farmer) {
            let notify = notification({ 
                message: "Please select a farmer", 
                type: 'warning' 
            });
            notify();
            return;
        }

        if (addListArry.length === 0) {
            let notify = notification({ 
                message: "Please add at least one product", 
                type: 'warning' 
            });
            notify();
            return;
        }

        setSubmitLoading(true);

        let prodList = [];
        let qtyList = [];
        let uomList = [];
        let unitPriceList = [];
        let totalPriceList = [];
        let gradeList = [];

        addListArry.map(row => {
            prodList.push(row.product);
            qtyList.push(row.qty);
            uomList.push(row.unit);
            unitPriceList.push(row.rate);
            totalPriceList.push(Number(row.qty) * Number(row.rate));
            gradeList.push(row.grade);
        });

        prodList = JSON.stringify(prodList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        qtyList = JSON.stringify(qtyList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        uomList = JSON.stringify(uomList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        unitPriceList = JSON.stringify(unitPriceList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        totalPriceList = JSON.stringify(totalPriceList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        gradeList = JSON.stringify(gradeList).replaceAll('","', ',').replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');

        let postData = [{
            "org_id": sessionStorage.getItem('org_id'),
            "user_id": sessionStorage.getItem('user_id'),
            "trn_type": 1,
            "farmer_id": farmer,
            "sale_date": getTodayDate(),
            "product_id": prodList,
            "grade_id": gradeList,
            "qty": qtyList,
            "uom": uomList,
            "unit_price": unitPriceList,
            "sale_price": totalPriceList,
            "sale_time": new Date().toLocaleTimeString(),
            "tax": "0",
        }];

        axios({
            method: 'post',
            url: mainurl + 'Commercial/produce_sale_purchase',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                setSubmitLoading(false);
                let notify = notification({ 
                    message: "Purchase submitted successfully!", 
                    type: 'success', 
                    time: true, 
                    position: 'center' 
                });
                notify();
                back();
            })
            .catch(error => {
                setSubmitLoading(false);
                let notify = notification({ 
                    message: "Failed to submit purchase. Please try again.", 
                    type: 'error' 
                });
                notify();
            });
    }

    const getProgressValue = () => {
        let progress = 0;
        if (state !== '0') progress += 20;
        if (district !== '0') progress += 20;
        if (block !== '0') progress += 20;
        if (farmer) progress += 20;
        if (addListArry.length > 0) progress += 20;
        return progress;
    }

    const getLocationSteps = () => {
        const steps = [
            { label: 'State', completed: state !== '0', icon: FaMapMarkerAlt },
            { label: 'District', completed: district !== '0', icon: FaMapMarkerAlt },
            { label: 'Block', completed: block !== '0', icon: FaMapMarkerAlt },
            { label: 'Farmer', completed: farmer !== '', icon: FaUserTie },
            { label: 'Products', completed: addListArry.length > 0, icon: FaLeaf }
        ];
        return steps;
    }

    return(
        <>
            {/* Header Card */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className='bg-gradient-success text-white'>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-3">
                            <FaLeaf size={24} />
                            <div>
                                <h5 className="mb-0">Produce Purchase</h5>
                                <small className="opacity-75">Purchase agricultural products from farmers</small>
                            </div>
                        </div>
                        <Button 
                            color='light' 
                            size="sm" 
                            onClick={back}
                            className="d-flex align-items-center gap-2"
                        >
                            <FaArrowLeft size={14} />
                            Back
                        </Button>
                    </div>
                </CardHeader>
            </Card>

            {/* Progress Indicator */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardBody className="py-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <small className="text-muted">Setup Progress</small>
                        <small className="text-muted">{getProgressValue()}% Complete</small>
                    </div>
                    <Progress 
                        value={getProgressValue()} 
                        color={getProgressValue() === 100 ? "success" : "info"}
                        className="mb-3"
                        style={{ height: '8px' }}
                    />
                    
                    {/* Progress Steps */}
                    <div className="d-flex justify-content-between">
                        {getLocationSteps().map((step, index) => (
                            <div key={index} className="text-center">
                                <div className={`rounded-circle d-flex align-items-center justify-content-center mx-auto mb-1 ${
                                    step.completed ? 'bg-success text-white' : 'bg-light text-muted'
                                }`} style={{ width: '32px', height: '32px' }}>
                                    {step.completed ? <FaCheck size={12} /> : <step.icon size={12} />}
                                </div>
                                <small className={step.completed ? 'text-success fw-bold' : 'text-muted'}>
                                    {step.label}
                                </small>
                            </div>
                        ))}
                    </div>
                </CardBody>
            </Card>

            {/* Location Selection */}
            <Card className='mb-4 border-0 shadow-sm'>
                <CardHeader className="bg-light border-bottom">
                    <div className="d-flex align-items-center gap-2">
                        <FaMapMarkerAlt className="text-primary" />
                        <h6 className="mb-0">Location Selection</h6>
                    </div>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col lg={3} md={6} className="mb-3">
                            <Label for="state" className="fw-bold text-dark">
                                <FaMapMarkerAlt size={12} className="me-1" />
                                State *
                            </Label>
                            <Input 
                                id="state" 
                                bsSize="sm" 
                                type="select" 
                                value={state} 
                                onChange={get_dist_list}
                                className="form-select-sm"
                            >
                                <option value="0">Select State</option>
                                {stateOpt}
                            </Input>
                        </Col>
                        <Col lg={3} md={6} className="mb-3">
                            <Label for="district" className="fw-bold text-dark">
                                <FaMapMarkerAlt size={12} className="me-1" />
                                District *
                            </Label>
                            <Input 
                                id="district" 
                                bsSize="sm" 
                                type="select" 
                                value={district} 
                                onChange={get_block_list}
                                className="form-select-sm"
                                disabled={state === '0'}
                            >
                                <option value="0">Select District</option>
                                {districtOpt}
                            </Input>
                        </Col>
                        <Col lg={3} md={6} className="mb-3">
                            <Label for="block" className="fw-bold text-dark">
                                <FaMapMarkerAlt size={12} className="me-1" />
                                Block *
                            </Label>
                            <Input 
                                id="block" 
                                bsSize="sm" 
                                type="select" 
                                value={block} 
                                onChange={(e) => setBlock(e.target.value)}
                                className="form-select-sm"
                                disabled={district === '0'}
                            >
                                <option value="0">Select Block</option>
                                {blockOpt}
                            </Input>
                        </Col>
                        <Col lg={3} className="mb-3 d-flex align-items-end">
                            <Button 
                                color='primary' 
                                size="sm" 
                                onClick={get_farmer_list} 
                                disabled={block === '0' || farmerLoading}
                                className="d-flex align-items-center gap-2 w-100"
                            >
                                {farmerLoading ? (
                                    <>
                                        <Spinner size="sm" />
                                        Loading...
                                    </>
                                ) : (
                                    <>
                                        <FaSearch size={14} />
                                        Get Farmers
                                    </>
                                )}
                            </Button>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Farmer Selection */}
            {farmerList && (
                <Card className='mb-4 border-0 shadow-sm'>
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaUserTie className="text-primary" />
                            <h6 className="mb-0">Farmer Selection</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col lg={8}>
                                <Label for="farmer" className="fw-bold text-dark">
                                    <FaUsers size={12} className="me-1" />
                                    Select Farmer *
                                </Label>
                                <Input 
                                    id="farmer" 
                                    bsSize="sm" 
                                    type="select" 
                                    value={farmer} 
                                    onChange={(e) => setFarmer(e.target.value)}
                                    className="form-select-sm"
                                    required
                                >
                                    <option value="">Select Farmer</option>
                                    {farmerList}
                                </Input>
                            </Col>
                            <Col lg={4} className="d-flex align-items-end">
                                {farmer && (
                                    <Badge color="success" pill className="px-3 py-2">
                                        <FaCheck size={12} className="me-1" />
                                        Farmer Selected
                                    </Badge>
                                )}
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            )}

            {/* Product Addition Form */}
            {farmer && (
                <Card className='mb-4 border-0 shadow-sm'>
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex align-items-center gap-2">
                            <FaLeaf className="text-success" />
                            <h6 className="mb-0">Add Products</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={updateRow ? update_edit_handler : add_row_handler}>
                            <Row>
                                <Col lg={2} md={6} className="mb-3">
                                    <Label for="category" className="fw-bold text-dark">Category *</Label>
                                    <Input 
                                        id="category" 
                                        bsSize="sm" 
                                        type="select" 
                                        value={category} 
                                        onChange={(e) => {setCategory(e.target.value); get_product_list(e.target.value)}}
                                        className="form-select-sm"
                                        required
                                    >
                                        <option value="0">Select Category</option>
                                        <option value="1">Nutrition</option>
                                        <option value="2">Horticulture</option>
                                        <option value="3">Aromatic</option>
                                        <option value="4">Vegetable</option>
                                        <option value="5">Apiary</option>
                                    </Input>
                                </Col>
                                <Col lg={2} md={6} className="mb-3">
                                    <Label for="product" className="fw-bold text-dark">
                                        <FaLeaf size={12} className="me-1" />
                                        Produce *
                                    </Label>
                                    <Input 
                                        id="product" 
                                        bsSize="sm" 
                                        type="select" 
                                        value={product} 
                                        onChange={(e) => {
                                            setProduct(e.target.value); 
                                            setProductName(e.target.selectedOptions[0].text);
                                        }}
                                        className="form-select-sm"
                                        required
                                    >
                                        <option value="0">Select Product</option>
                                        {prodOpt}
                                    </Input>
                                </Col>
                                <Col lg={2} md={6} className="mb-3">
                                    <Label for="grade" className="fw-bold text-dark">
                                        <FaStar size={12} className="me-1" />
                                        Grade *
                                    </Label>
                                    <Input 
                                        id="grade" 
                                        bsSize="sm" 
                                        type="select" 
                                        value={grade} 
                                        onChange={(e) => {
                                            setGrade(e.target.value); 
                                            setGradeName(e.target.selectedOptions[0].text);
                                        }}
                                        className="form-select-sm"
                                        required
                                    >
                                        <option value="0">Select Grade</option>
                                        <option value="1">Grade-1 (Good)</option>
                                        <option value="2">Grade-2 (Average)</option>
                                        <option value="3">Grade-3 (Poor)</option>
                                    </Input>
                                </Col>
                                <Col lg={1} md={6} className="mb-3">
                                    <Label for="qty" className="fw-bold text-dark">
                                        <FaWeight size={12} className="me-1" />
                                        Qty *
                                    </Label>
                                    <Input 
                                        id="qty" 
                                        bsSize="sm" 
                                        type="number" 
                                        value={qty} 
                                        onChange={(e) => setQty(e.target.value)} 
                                        placeholder="0"
                                        min="0.01"
                                        step="0.01"
                                        required
                                    />  
                                </Col>
                                <Col lg={2} md={6} className="mb-3">
                                    <Label for="unit" className="fw-bold text-dark">Unit *</Label>
                                    <Input 
                                        id="unit" 
                                        bsSize="sm" 
                                        type="select" 
                                        value={unit} 
                                        onChange={(e) => {
                                            setUnit(e.target.value);  
                                            setUnitName(e.target.selectedOptions[0].text);
                                        }} 
                                        className="form-select-sm"
                                        required
                                    >
                                        <option value="0">Select Unit</option>
                                        <option value="1">Gm</option>
                                        <option value="2">Kg</option>
                                        <option value="3">Ton</option>
                                        <option value="4">Packet</option>
                                    </Input>
                                </Col>
                                <Col lg={2} md={6} className="mb-3">
                                    <Label for="rate" className="fw-bold text-dark">
                                        <FaRupeeSign size={12} className="me-1" />
                                        Rate/Unit *
                                    </Label>
                                    <Input 
                                        id="rate" 
                                        bsSize="sm" 
                                        type="number" 
                                        value={rate} 
                                        onChange={(e) => setRate(e.target.value)} 
                                        placeholder="0.00"
                                        min="0.01"
                                        step="0.01"
                                        required
                                    />  
                                </Col>
                                <Col lg={1} className="mb-3 d-flex align-items-end">
                                    {updateRow ? (
                                        <Button 
                                            color='warning' 
                                            size="sm" 
                                            onClick={update_edit_handler}
                                            className="d-flex align-items-center gap-2 w-100"
                                        >
                                            <FaEdit size={14} />
                                            Update
                                        </Button>
                                    ) : (
                                        <Button 
                                            color='success' 
                                            size="sm" 
                                            type="submit"
                                            className="d-flex align-items-center gap-2 w-100"
                                        >
                                            <FaPlusCircle size={14} />
                                            Add
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                            {qty && rate && (
                                <Row className="mt-2">
                                    <Col xs={12}>
                                        <Alert color="info" className="py-2 mb-0">
                                            <div className="d-flex align-items-center gap-2">
                                                <FaCalculator size={14} />
                                                <span>
                                                    <strong>Line Total: ₹{(parseFloat(qty || 0) * parseFloat(rate || 0)).toFixed(2)}</strong>
                                                </span>
                                            </div>
                                        </Alert>
                                    </Col>
                                </Row>
                            )}
                        </Form>
                    </CardBody>
                </Card>
            )}

            {/* Product List */}
            {addListArry.length > 0 && (
                <Card className='mb-4 border-0 shadow-sm'>
                    <CardHeader className="bg-light border-bottom">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-2">
                                <FaLeaf className="text-success" />
                                <h6 className="mb-0">Added Products</h6>
                            </div>
                            <Badge color="success" pill>
                                {addListArry.length} item{addListArry.length > 1 ? 's' : ''}
                            </Badge>
                        </div>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="py-3">#</th>
                                        <th className="py-3">Product</th>
                                        <th className="py-3">Grade</th>
                                        <th className="py-3">Qty</th>
                                        <th className="py-3">Unit</th>
                                        <th className="py-3">Rate/Unit</th>
                                        <th className="py-3">Total</th>
                                        <th className="py-3 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {addListArry.map((row, index) => (
                                        <tr key={index}>
                                            <td className="py-3">
                                                <Badge color="secondary" pill>{index + 1}</Badge>
                                            </td>
                                            <td className="py-3">
                                                <div className="fw-bold text-dark">{row.productName}</div>
                                            </td>
                                            <td className="py-3">
                                                <Badge 
                                                    color={row.grade === '1' ? 'success' : row.grade === '2' ? 'warning' : 'danger'} 
                                                    className="text-white"
                                                >
                                                    {row.gradeName}
                                                </Badge>
                                            </td>
                                            <td className="py-3">{row.qty}</td>
                                            <td className="py-3">
                                                <Badge color="info" className="text-white">{row.unitName}</Badge>
                                            </td>
                                            <td className="py-3">₹{parseFloat(row.rate).toFixed(2)}</td>
                                            <td className="py-3">
                                                <span className="fw-bold text-success">
                                                    ₹{(parseFloat(row.qty) * parseFloat(row.rate)).toFixed(2)}
                                                </span>
                                            </td>
                                            <td className="py-3 text-center">
                                                <div className="d-flex gap-2 justify-content-center">
                                                    <Button
                                                        color="warning"
                                                        size="sm"
                                                        outline
                                                        onClick={() => edit_handler(row, index)}
                                                        className="d-flex align-items-center"
                                                    >
                                                        <FaEdit size={12} />
                                                    </Button>
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        outline
                                                        onClick={() => delete_handler(index)}
                                                        className="d-flex align-items-center"
                                                    >
                                                        <FaTrash size={12} />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                    <CardFooter className="bg-light">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <div className="d-flex align-items-center gap-2">
                                    <FaCalculator className="text-success" />
                                    <span className="text-muted">Grand Total:</span>
                                    <span className="h5 mb-0 text-success fw-bold">
                                        ₹{Number(totalPrice).toFixed(2)}
                                    </span>
                                </div>
                            </Col>
                            <Col md={6} className="text-md-end">
                                <Button 
                                    color='success' 
                                    size="sm" 
                                    onClick={sale_handler}
                                    disabled={submitLoading || !farmer || addListArry.length === 0}
                                    className="d-flex align-items-center gap-2"
                                >
                                    {submitLoading ? (
                                        <>
                                            <Spinner size="sm" />
                                            Processing...
                                        </>
                                    ) : (
                                        <>
                                            <FaSave size={14} />
                                            Submit Purchase
                                        </>
                                    )}
                                </Button>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            )}

            {/* Summary Card - Always visible when farmer is selected */}
            {farmer && (
                <Card className='border-0 shadow-sm'>
                    <CardHeader className="bg-gradient-success text-white">
                        <div className="d-flex align-items-center gap-2">
                            <FaShoppingCart size={18} />
                            <h6 className="mb-0">Purchase Summary</h6>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col md={3} className="mb-3 mb-md-0">
                                <div className="text-center p-3 bg-light rounded">
                                    <FaLeaf size={24} className="text-success mb-2" />
                                    <div className="h5 mb-0">{addListArry.length}</div>
                                    <small className="text-muted">Products Added</small>
                                </div>
                            </Col>
                            <Col md={3} className="mb-3 mb-md-0">
                                <div className="text-center p-3 bg-light rounded">
                                    <FaWeight size={24} className="text-info mb-2" />
                                    <div className="h5 mb-0">
                                        {addListArry.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0).toFixed(2)}
                                    </div>
                                    <small className="text-muted">Total Quantity</small>
                                </div>
                            </Col>
                            <Col md={3} className="mb-3 mb-md-0">
                                <div className="text-center p-3 bg-light rounded">
                                    <FaStar size={24} className="text-warning mb-2" />
                                    <div className="h5 mb-0">
                                        {addListArry.length > 0 ? 
                                            addListArry.filter(item => item.grade === '1').length > addListArry.length / 2 ? 'High' :
                                            addListArry.filter(item => item.grade === '2').length > addListArry.length / 2 ? 'Medium' : 'Mixed'
                                            : 'N/A'
                                        }
                                    </div>
                                    <small className="text-muted">Average Grade</small>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="text-center p-3 bg-light rounded">
                                    <FaRupeeSign size={24} className="text-success mb-2" />
                                    <div className="h5 mb-0 text-success">
                                        ₹{Number(totalPrice || 0).toFixed(2)}
                                    </div>
                                    <small className="text-muted">Total Amount</small>
                                </div>
                            </Col>
                        </Row>
                        
                        {addListArry.length === 0 && (
                            <Alert color="warning" className="mt-3 mb-0">
                                <div className="d-flex align-items-center gap-2">
                                    <FaLeaf size={16} />
                                    <span>No products added yet. Please add products to proceed with the purchase.</span>
                                </div>
                            </Alert>
                        )}
                    </CardBody>
                    
                    {addListArry.length > 0 && (
                        <CardFooter className="text-center">
                            <Button 
                                color='success' 
                                size="lg" 
                                onClick={sale_handler}
                                disabled={submitLoading}
                                className="d-flex align-items-center gap-2 mx-auto px-4"
                            >
                                {submitLoading ? (
                                    <>
                                        <Spinner size="sm" />
                                        Processing Purchase...
                                    </>
                                ) : (
                                    <>
                                        <FaSave size={16} />
                                        Complete Purchase Transaction
                                    </>
                                )}
                            </Button>
                        </CardFooter>
                    )}
                </Card>
            )}

            <style jsx>{`
                .form-select-sm {
                    font-size: 0.875rem;
                }
                .bg-gradient-success {
                    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
                }
                .bg-gradient-primary {
                    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
                }
                .card {
                    transition: all 0.3s ease;
                }
                .card:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
                }
                .table th {
                    font-weight: 600;
                    font-size: 0.875rem;
                    border-bottom: 2px solid #dee2e6;
                }
                .table td {
                    font-size: 0.875rem;
                    vertical-align: middle;
                }
                .table-hover tbody tr:hover {
                    background-color: rgba(40,167,69,0.05);
                }
                .btn {
                    transition: all 0.2s ease;
                }
                .btn:hover {
                    transform: translateY(-1px);
                }
                .progress {
                    border-radius: 10px;
                }
                .badge {
                    font-size: 0.75rem;
                }
                .alert {
                    border-radius: 8px;
                }
            `}</style>
        </>
    )
}
export default ProducePurchase;